module.exports = __webpack_public_path__ + "img/product15.82ed590d.jpg";